export const momentConstants = {
  FORMAT: 'DD/MM/YYYY à H:mm',
  FORMAT_WITH_SC: 'DD/MM/YYYY à H:mm:ss',
  FORMAT_DATE: 'DD/MM/YYYY',
  FORMAT_file: 'DD-MM-YYYY',
  FORMAT_text_field: 'YYYY-MM-DD',
  FORMAT_INIT: 'lll',
}
